import { Controller } from "stimulus"

// #1732: de filters van het bord werken direct: een keuze past ze meteen toe,
// zoeken na een korte pauze in het typen.
export default class extends Controller {
  kies() {
    this.element.requestSubmit()
  }

  typ() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.element.requestSubmit(), 400)
  }
}
